import { GetInTouchProps } from 'components/commercial/get-in-touch';
import { LOCALE_EXP_COMMERCIAL_CA_PATHS } from 'types/locales';

export const getInTouchConfig: GetInTouchProps = {
  mediaType: 'image',
  imageSrc: '/next/assets/images/exp-commercial/ca/contact-us.webp',
  title: LOCALE_EXP_COMMERCIAL_CA_PATHS.GET_IN_TOUCH_TITLE,
  description: LOCALE_EXP_COMMERCIAL_CA_PATHS.GET_IN_TOUCH_DESCRIPTION,
  contactButton: LOCALE_EXP_COMMERCIAL_CA_PATHS.GET_IN_TOUCH_CONTACT_BUTTON,
  joinButton: LOCALE_EXP_COMMERCIAL_CA_PATHS.GET_IN_TOUCH_JOIN_BUTTON,
};

